const tab_sections = {
    overview: "Vue d'ensemble",
    authentication: 'Authentification',
    authorization: 'Autorisation',
    users: 'Utilisateurs',
    developer: 'Développeur',
    tenant: 'Locataire',
};
export default Object.freeze(tab_sections);
